StageRenderer = require "core/StageRenderer"
Stage3d = require "core/Stage3d"
SceneTraveler = require "core/scenes/SceneTraveler"
HomeScene = require "HomeScene"

#---------------------------------------------------------- Class Main

class Main

	mouse = {x:0,y:0}
	
	@init = ()->
		StageRenderer.onUpdate.add(SceneTraveler.update)
		StageRenderer.onResize.add(SceneTraveler.resize)
		StageRenderer.onResize.add(Stage3d.resize)
		SceneTraveler.to(new HomeScene())
		return

	document.addEventListener('DOMContentLoaded', ()->
		Main.init()
		return
	)

	document.addEventListener( 'touchstart', (e)->
		Stage3d.onMouseDown()
	)

	document.addEventListener( 'click', (e)->
		Stage3d.onMouseDown()	
	)

	document.addEventListener('mousemove', (e)->
		mouse.x = e.pageX;
		mouse.y = e.pageY;
		Stage3d.mouse.x = e.pageX;
		Stage3d.mouse.y = e.pageY;
		Stage3d.umouse.x = (e.pageX/window.innerWidth-0.5)*2;
		Stage3d.umouse.y = (e.pageY/window.innerHeight-0.5)*2;
		#console.log(mouse)
		return
	)

	document.addEventListener('touchmove', (e)->
		touchobj = e.changedTouches[0];
		mouse.x = touchobj.clientX;
		mouse.y = touchobj.clientY;
		Stage3d.mouse.x = mouse.x;
		Stage3d.mouse.y = mouse.y;
		Stage3d.umouse.x = ( touchobj.clientX / window.innerWidth ) * 2 - 1;
		Stage3d.umouse.y = ( touchobj.clientY / window.innerHeight ) * 2 - 1;
		return
	)	

module.exports = Main


/** WEBPACK FOOTER **
 ** ./src/coffee/Main.coffee
 **/